import { Component, OnInit, Injector } from '@angular/core';

import { MainService } from 'app/resources/services/main.service';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.css']
})
export class AppFooterComponent {

  public isCustomized: boolean;

  constructor(public mainService: MainService) {
    if (location.pathname.replace(/\//g, '')) {
      this.isCustomized = true;
    }
  }

  public readPoliciesAndTerms() {
    window.open('#/politicas-e-termos', '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/app-footer/app-footer.component.ts